import {
	EssityColumnProps,
	filterType,
} from '@components/shared/paginatedEssityTable/GridHelper';
import { useRootData } from '@hooks/hook';
import { DictionariesConstants } from '@services/DictionariesConstants';
import * as PortalStatusMapper from '@services/mappers/PortalStatus';
import {
	PharmacyBulkInvitationDto,
	PharmacyUserType,
	PortalStatus,
} from '@services/src/models';
import { Space, Tag } from 'antd';
import React from 'react';
import { IDictionaryStore } from 'stores/DictionaryStore';

export const GetPharmaciesInvitationTableColumns = (): EssityColumnProps<PharmacyBulkInvitationDto>[] => {
	const dictionaryStore: IDictionaryStore = useRootData(
		(store) => store.dictionaryStore
	);

	return [
		{
			dataIndex: 'name',
			key: 'name',
			title: 'Name',
			width: 200,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'voivodeshipId',
			key: 'voivodeshipId',
			title: 'Voivodeship',
			width: 160,
			sorter: true,
			filter: 'dictionary' as filterType,
			filterDictionary: DictionariesConstants.Voivodeships,
			render: (value: number) => {
				return dictionaryStore.getValueById(
					DictionariesConstants.Voivodeships,
					value
				);
			},
		},
		{
			dataIndex: 'city',
			key: 'city',
			title: 'City',
			width: 160,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'street',
			key: 'street',
			title: 'Street',
			width: 150,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'taxNumber',
			key: 'taxNumber',
			title: 'NIP',
			width: 160,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'pharmacyChain',
			key: 'pharmacyChain',
			title: 'Pharmacy Chain',
			width: 160,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'companyName',
			key: 'companyName',
			title: 'Company Name',
			width: 200,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'portalMail',
			key: 'portalMail',
			title: 'Portal mail',
			width: 220,
			sorter: true,
			filter: 'contains' as filterType,
			render: (value: string, record: PharmacyBulkInvitationDto) => {
				const mainUser = record.pharmacyUsers?.find(
					(u) => u.type === PharmacyUserType.Main
				);
				const status = mainUser?.portalStatus as PortalStatus;
				const isSentOrAccess =
					status === PortalStatus.Sent ||
					status === PortalStatus.Access;

				return isSentOrAccess ? (
					<Tag color="#32387e">{PortalStatusMapper.map(status)}</Tag>
				) : (
					<span>{value}</span>
				);
			},
		},
		{
			dataIndex: 'secondaryPortalMail',
			key: 'secondaryPortalMail',
			title: 'Secondary mail',
			width: 220,
			sorter: true,
			filter: 'contains' as filterType,
			render: (value: string, record: PharmacyBulkInvitationDto) => {
				const secondaryUser = record.pharmacyUsers?.find(
					(u) => u.type === PharmacyUserType.Secondary
				);
				const status = secondaryUser?.portalStatus as PortalStatus;
				const isSentOrAccess =
					status === PortalStatus.Sent ||
					status === PortalStatus.Access;

				return isSentOrAccess ? (
					<Tag color="#32387e">{PortalStatusMapper.map(status)}</Tag>
				) : (
					<span>{value}</span>
				);
			},
		},
	];
};
